import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export const deleteAvatar = async () => {
  return await axios.delete(`${rootUrl}/psychologist/delete/avatar`, {
    params: {
      token: getCookies('auth'),
    },
  });
};
